<template>
  <v-card class="url-encoder tools-view-card">
    <ToolbarHeader :name="'Url Encoder'"/>
    <v-container>
      <article class="ma-5">
        <label>
          Text
        </label>
        <v-form
            v-model="formOptions.valid"
        >
          <editor
              v-model="form.text"
              @init="initTextEditor"
              width="100%"
              height="60vh">
          </editor>
          <v-row>
            <v-col cols="12"
                   sm="4"
                   md="4">
              <v-checkbox
                  v-model="queryParameters"
                  label="Encode Query Parameters"
              />
            </v-col>
          </v-row>
          <v-btn
              @click="handleEncodeForm"
              color="primary"
              class="mr-4 mt-3"
          >
            Encode
          </v-btn>
        </v-form>
        <v-form class="mt-5">
          <label>
            Result
          </label>
          <editor
              v-model="form.result"
              @init="initTextEditor"
              width="100%"
              height="60vh">
          </editor>
          <v-btn
              @click="handleDecodeForm"
              color="primary"
              class="mr-4 mt-3"
          >
            Decode
          </v-btn>
        </v-form>
      </article>
    </v-container>
  </v-card>
</template>

<script>
import ToolbarHeader from "@/components/Toolbar-Header";
import {copyMixin} from "@/mixins/copyMixin";
import {aceEditorMixin} from "@/mixins/aceEditorMixin";

const form = {
  text: 'http://example.com?foo=bär',
  result: ''
};

export default {
  name: "Url-Encoder",
  mixins: [copyMixin, aceEditorMixin],
  components: {ToolbarHeader},
  data: () => ({
    form: Object.assign({}, form),
    formOptions: {
      valid: false,
      encode: [
        v => !!v || 'Url Encode is required',
      ],
    },
    queryParameters: false
  }),
  created() {
    window.scrollTo(0, 0);
  },
  methods: {
    handleEncodeForm() {
      try {
        if (!this.form.text) {
          return;
        }

        if (this.queryParameters) {
          const params = this.getParams(this.form.text);

          for (let key in params) {
            params[key] = encodeURIComponent(params[key])
          }

          let url = this.form.text.split('?')[0] + '?';
          const size = Object.keys(params).length;


          for (let key in params) {
            if (key) {
              if (size >= 2) {
                url = url += key + "=" + params[key] + "&"
              } else {
                url = url += key + "=" + params[key]
              }
            }
          }

          if (url.charAt(url.length - 1) === '&') {
            url = url.slice(0, -1);
          }

          return this.form.result = url;
        }

        this.form.result = encodeURIComponent(this.form.text);

      } catch (error) {
        this.$store
            .dispatch('SHOW_SNACKBAR',
                {
                  time: 2000,
                  content: error,
                  color: 'error'
                });
      }
    },
    getParams(url) {
      const params = {};
      const parser = document.createElement('a');
      parser.href = url;
      const query = parser.search.substring(1);
      const vars = query.split('&');
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
      }
      return params;
    },
    handleDecodeForm() {
      if (!this.form.result) {
        return;
      }

      this.form.text = decodeURIComponent(this.form.result);


    }
  }
}
</script>

<style scoped>

</style>
